export default __webpack_public_path__ + "731ba316cbbd7d51cd27f915e7ee2af9.svg";